// The page's view of the game: the calls onto the client core (client/webApi.ts) and the content as the page sees it.
import { webApi } from './client/webApi';

export const api = webApi;

// --- content (client/contentExport.ts) --------------------------------------------------------------------

export interface ItemDef {
  id: number; key: string; name: string; icon: string; quality: number; qualityColor: string; maxStack: number;
  tool: string; armor: number; armorValue: number; look: string; sellPrice: number; heals: number; consumable: boolean;
  binding: string; belt: number; offhand: string; jewelry: string; unique: boolean;
  weapon?: { class: string; damage: number; reach: number; arc: number; cooldown: number; mana: number; ammo: number; ranged: boolean };
}
export interface NpcDef { id: number; name: string; appearance: number; greeting: string; vendor: boolean; outfit: number[] }
export interface MobDef { id: number; name: string; sprite: string; tint: string }
export interface RecipeDef { id: number; station: string; item: number; count: number; inputs: { item: number; count: number }[] }
export interface TileDef { baseGround: number; id: number; name: string; layer: 'ground' | 'object'; solid: boolean; animated: boolean; sprite: string; join: string; joinsWith: string[]; blend: number; lightRadius: number; lightColor: string; lightX: number; lightY: number; flat: boolean; sortY: number }
export interface TileEntityDef { id: number; key: string; name: string; w: number; h: number; solid: boolean; verb: string }

export interface Content {
  tileSize: number; chunkSize: number; tickRate: number; appearances: number; maxNameLength: number; maxChat: number;
  maxFriends: number; maxIgnored: number;
  bagColumns: number; bagRows: number; protocol: number;
  items: ItemDef[]; npcs: NpcDef[]; mobs: MobDef[]; recipes: RecipeDef[]; tiles: TileDef[]; tileEntities: TileEntityDef[];
  armorSlots: string[]; beltSlots: string[];
  named: Record<string, number>;
}

export let content: Content;
export const itemsById = new Map<number, ItemDef>();
export const npcsById = new Map<number, NpcDef>();
export const mobsById = new Map<number, MobDef>();

let contentVersion = -1;

export function setContent(c: Content): void {
  content = c;
  itemsById.clear();
  npcsById.clear();
  mobsById.clear();
  for (const i of c.items) itemsById.set(i.id, i);
  for (const n of c.npcs) npcsById.set(n.id, n);
  for (const m of c.mobs) mobsById.set(m.id, m);
}

/**
 * Takes the content in effect again if it changed: a world whose content differs from the page's sends its own when
 * connecting (before the character list), so screens made after that see the world's items, tiles and NPCs.
 */
export function refreshContent(): void {
  const version = api.contentVersion();
  if (version === contentVersion) return;
  contentVersion = version;
  setContent(api.content() as Content);
}

/** Containers, as on the wire (ContainerId). */
export const Container = { Main: 0, Belt: 1, Armor: 2 } as const;
